import {EmployeeRef, INeighbourhood} from "../../../api/Model";
import {AssignedDesks} from "../../../api/AssignedDeskStore";
import {EmployeeVisitSheet} from "../../../api/EmployeeVisitStore";
import {EmployeeNeighbourhood} from "../../../api/EmployeeNeighbourhoodStore";
import {EmployeeVisitFigure, workDayVisitCounter} from "../../employee-visit-report/EmployeeVisitReportFilter";
import {combineCmp, numberCmp, stringCmp} from "../../../util/SortUtil";

export const REGULAR_OFFICE_ATTENDANCE_THRESHOLD_PERCENT = 70;

export type RegularOfficeEmployeeWithoutAssignedDesk = {
    employee: EmployeeRef,
    neighbourhoods: INeighbourhood[],
    visits: EmployeeVisitFigure,
};

export function findRegularOfficeEmployeesWithoutAssignedDesks(
    employeeVisits: EmployeeVisitSheet,
    assignedDesks: AssignedDesks,
    employeeNeighbourhoods: EmployeeNeighbourhood,
): RegularOfficeEmployeeWithoutAssignedDesk[] {
    const countVisits = workDayVisitCounter(employeeVisits.dates);

    return employeeVisits.rows
        .flatMap(row => {
            const visits = countVisits(row);
            return !row.value.deactivated
                && visits.percent >= REGULAR_OFFICE_ATTENDANCE_THRESHOLD_PERCENT
                && assignedDesks.desksOf(row.value).length === 0
                ? [{
                    employee: row.value,
                    neighbourhoods: employeeNeighbourhoods.get(row.value),
                    visits,
                }]
                : [];
        })
        .sort(combineCmp(
            numberCmp(row => row.visits.percent, true),
            stringCmp(row => row.employee.fullName),
        ));
}
